import styled from "@emotion/styled";
import { Button, Typography } from "@mui/material";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.colors.background};
  justify-content: space-between;
  border: 1px solid ${(p) => p.theme.colors.border2};
  border-radius: 0.75rem;
  padding: 0.5rem 0.75rem;
  /* height: 100%; */
  /* border-top: 0.25rem solid ${(p) => p.theme.colors.primary}; */

  ${(p) => p.theme.media.mobileDown} {
    grid-template-columns: 1fr;
  }

  &[aria-disabled="true"] {
    opacity: 0.5;
    pointer-events: none;
    * {
      pointer-events: none;
    }
  }
`;

export const ProductInfo = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
`;

export const ProductNameContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.5rem;
  align-items: center;
  ${(p) => p.theme.media.mobileDown} {
    grid-template-columns: 1fr;
    row-gap: 1rem;
  }

  p {
    font-family: ${(p) => p.theme.title.fonts.primary};
    font-size: ${(p) => p.theme.title.fontSizes.h6};
    font-weight: 600;
    color: ${(p) => p.theme.text.colors.primary};
  }
`;

export const ProductDescription = styled(Typography)`
  color: ${(p) => p.theme.text.colors.secondary};
  font-size: ${(p) => p.theme.text.fontSizes.m};
  line-height: 120%;
  max-width: calc(100% - 2rem);

  ${(p) => p.theme.media.laptopDown} {
    max-width: 100%;
  }
`;

export const ErrorDescription = styled(ProductDescription)`
  color: ${(p) => p.theme.colors.error};
`;

export const TotalInfo = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
`;

export const TotalItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    line-height: 100%;
    font-size: ${(p) => p.theme.text.fontSizes.l};
  }
`;

export const Price = styled(Typography)`
  color: ${(p) => p.theme.text.colors.primary};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: ${(p) => p.theme.text.fonts.primary};
  font-size: ${(p) => p.theme.text.fontSizes.l}!important;

  .next-payment-date {
    font-size: ${(p) => p.theme.text.fontSizes.s}!important;
    margin-right: 0.25rem;
  }
`;
export const PriceDiscountGroup = styled.span`
  display: flex;
  gap: 0.5rem;
`;
export const PriceText = styled.span``;
export const PriceTextLineThrough = styled.span`
  font-size: ${(p) => p.theme.text.fontSizes.m};
  color: ${(p) => p.theme.text.colors.secondary};
  text-decoration: line-through;
`;

export const TrialLabel = styled.span<{ $color: "error" | "warning" }>`
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  line-height: 100%;
  background-color: ${(p) =>
    p.$color === "warning"
      ? p.theme.colors.background
      : p.theme.colors.background};
  color: ${(p) =>
    p.$color === "warning"
      ? p.theme.text.colors.primary
      : p.theme.colors.error};
  border: solid 1px ${(p) => p.theme.colors.border2};
  font-size: ${(p) => p.theme.text.fontSizes.s};
  font-weight: 300;
  justify-self: flex-start;
  cursor: default;
`;

export const SubscriptionCancelledContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  p {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 1rem;
`;

export const ActionButton = styled(Button)`
  padding: 0;
  text-decoration: underline;
  &:hover,
  &:focus {
    background: transparent;
    text-decoration: underline;
  }
`;
